module.exports = __webpack_public_path__ + "img/bac27c3.png";